function Services() {
    return (
      <div className="container my-5">
        <h1 className="text-center mb-5">Comprehensive Women's Health Services</h1>
        
        <div className="row g-4">
          <div className="col-md-4">
            <div className="card h-100">
              <div className="card-header bg-primary text-white">
                <h4>Reproductive Health</h4>
              </div>
              <div className="card-body">
                <ul className="list-group list-group-flush">
                  <li className="list-group-item">Family planning</li>
                  <li className="list-group-item">Prenatal/postnatal care</li>
                  <li className="list-group-item">Menopause management</li>
                </ul>
              </div>
            </div>
          </div>
  
          <div className="col-md-4">
            <div className="card h-100">
              <div className="card-header bg-primary text-white">
                <h4>Preventive Care</h4>
              </div>
              <div className="card-body">
                <ul className="list-group list-group-flush">
                  <li className="list-group-item">Cancer screenings</li>
                  <li className="list-group-item">Vaccinations</li>
                  <li className="list-group-item">Bone density tests</li>
                </ul>
              </div>
            </div>
          </div>
  
          <div className="col-md-4">
            <div className="card h-100">
              <div className="card-header bg-primary text-white">
                <h4>Specialized Care</h4>
              </div>
              <div className="card-body">
                <ul className="list-group list-group-flush">
                  <li className="list-group-item">Pelvic floor therapy</li>
                  <li className="list-group-item">Infertility treatment</li>
                  <li className="list-group-item">Chronic disease management</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  export default Services;